import './index.scss';
import React from 'react';
import { useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';
const DocumentComparisonHeader = () => {
    const { id: comparisonId } = useParams();
    const location = useLocation();
    const onGridView = location.pathname.endsWith('grid');
    return React.createElement("div", { className: 'comparison-view-header', "data-testid": 'grid-view-header', "data-public": true },
        React.createElement("div", { className: 'page-title' }, "Document Comparison"),
        React.createElement("div", { className: 'nav-toggle' },
            React.createElement("div", { className: 'toggle grid', title: 'Grid Comparison View' }, onGridView
                ? React.createElement("i", { className: 'fas fa-table fa-fw active' })
                : React.createElement(Link, { to: `/compare/${comparisonId}/grid` },
                    React.createElement("i", { className: 'fas fa-table fa-fw' }))),
            React.createElement("div", { className: 'toggle file', title: 'Switch to Grid View' }, onGridView
                ? React.createElement(Link, { to: `/compare/${comparisonId}/documents` },
                    React.createElement("i", { className: 'fas fa-file fa-fw' }))
                : React.createElement("i", { className: 'fas fa-file fa-fw active' }))));
};
export default DocumentComparisonHeader;
